import script from "./DoubleRangeSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoubleRangeSlider.vue?vue&type=script&setup=true&lang=ts"

import "./DoubleRangeSlider.vue?vue&type=style&index=0&id=f7b870c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7b870c6"]])

export default __exports__